<div class="loading-container">
  <div class="circle"></div>
  <img src="assets/herb.svg" alt="loading icon" />
</div>
